
import {
    COUNTRY_LIST_ATTEMPT,
    COUNTRY_LIST_SUCCESS,
    COUNTRY_LIST_FAILED,
    //////////////////
    COUNTRY_UPDATE_SUCCESS,
    COUNTRY_UPDATE_FAILED,

} from '../types/countryTypes';

const INITIAL_STATE = {
    loading: false,
    list: [],
    error: '',
};
function country(state = INITIAL_STATE, action) {
    switch (action.type) {
        case COUNTRY_LIST_ATTEMPT:
            return {
                ...state,
                loading: true,
            }

        case COUNTRY_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                list: action.data.list,
                error: ''
            }

        case COUNTRY_LIST_FAILED:
            return {
                ...state,
                loading: false,
                error: action.error,
                list: []
            }
        ///////////////////////////


        default: return state;
    }
};
export default country;